export const initialState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  syncQueueCount: 0,
  pendingFileCount: 0,
  pendingFileSizeMb: 0,
  isSyncing: false,
  syncProgress: null,
  lastSyncedAt: null,
  syncErrors: []
}
